import { render, staticRenderFns } from "./HomeMirror.vue?vue&type=template&id=13edfd06&scoped=true"
import script from "./HomeMirror.vue?vue&type=script&lang=js"
export * from "./HomeMirror.vue?vue&type=script&lang=js"
import style0 from "./HomeMirror.vue?vue&type=style&index=0&id=13edfd06&prod&scoped=true&lang=css"
import style1 from "./HomeMirror.vue?vue&type=style&index=1&id=13edfd06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13edfd06",
  null
  
)

export default component.exports